import axios from 'axios'
import store from '@/store'

// Définir l'URL de base de l'API
axios.defaults.baseURL = process.env.VUE_APP_API_URL || 'https://lesactualites.fr'

// Ajouter un intercepteur pour les requêtes
axios.interceptors.request.use(
  config => {
    // Récupérer le token depuis le store
    const token = store.getters['auth/token']
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// Ajouter un intercepteur pour les réponses
axios.interceptors.response.use(
  response => {
    return response
  },
  error => {
    // Gérer les erreurs d'authentification
    if (error.response && error.response.status === 401) {
      store.dispatch('auth/logout')
    }
    return Promise.reject(error)
  }
)

export default axios